export default {
  init() {
    // JavaScript to be fired on the Housing page
    console.log('housing');

    $('#addressInput').keypress(function (e) {
      var key = e.which;
      if (key == 13) {
        // the enter key code
        $('#search_btn').click();
        // $('input[name = butAssignProd]').click();
        // return false;
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the Housing page, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/housing.js